import { Game } from 'chessboard/model/game/types';
import type { API } from 'chessboard/api/config/types';
import { Core } from 'chessboard/core/config/types';

/**
 * Create the resign method.
 */
export function createResign(context: API.Context) {
  /**
   * Resign the game as a specific color.
   */
  return function resign(color: Game.ColorsAsNumbers): API.Response {
    const { api, respond } = context;

    if (api.isGameOver()) {
      return null;
    }

    const result = color === Game.ColorsAsNumbers.White ? Game.Results.Black : Game.Results.White;

    api.setResult(result);

    return respond(Core.APIEvents.GameResigned, result);
  };
}
